<template>
    <a :href="link"
            rel="noopener noreferrer"
            class="copy-link"
            :class="{'copy-link__clicked': clicked}"
            @click.prevent="copyLink">
        <slot/>
    </a>
</template>

<script>
    export default {
        props: {
            link: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                clicked: false,
            };
        },
        methods: {
            copyLink() {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    return navigator.clipboard.writeText(this.link).then(() => this.showClickedIndicator());
                }
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('The Clipboard API is not available.');
            },
            showClickedIndicator() {
                this.clicked = true;
                setTimeout(() => {
                    this.clicked = false;
                }, 500);
            },
        },
    };
</script>
